import React, { useRef, useState, useEffect } from "react";
import { Outlet, useNavigate, useLocation } from "react-router-dom";
import LogoPico from "../assets/LogoPico.svg";
import IconButton from "@mui/material/IconButton";
import AccountCircleIcon from "@mui/icons-material/AccountCircle";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Logout from "@mui/icons-material/Logout";

//menu list mobile 
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import InfoIcon from '@mui/icons-material/Info';
import ContactSupportIcon from '@mui/icons-material/ContactSupport';
import NextWeekIcon from '@mui/icons-material/NextWeek';
import HelpIcon from '@mui/icons-material/Help';

import { obtenerSesion, cerrarSesion } from "../service/apiService";
import { Link } from "react-router-dom";

const MainLayout = () => {

  const navigate = useNavigate();
  const location = useLocation();
  const [profile, setProfile] = useState();
  const [isUserLogged, setUserLogged] = useState(false);

  const [dashboardVisible, setDashboardVisible] = useState(false);
  const [graficasVisible, setGraficasVisible] = useState(false);
  const [tablasVisible, setTablasVisible] = useState(false);

  //redirecciona a login si no hay token - si lo hay redirecciona a dashboard
  useEffect(() => {
    const token = localStorage.getItem("token");

    if (!token && location.pathname !== "/login") {
      navigate("/login");
    }

    if (token && location.pathname === "/login") {
      navigate("/");
    }

    //para detectar si el usuario se ha logueado
    token ? setUserLogged(true) : setUserLogged(false);

  }, [location]);


  //obtiene informacion del usuario logueado
  useEffect(() => {
    if(isUserLogged)
      getUserInformation();
  }, [isUserLogged])

  const getUserInformation = async() => {
    try
    {
      const response =  await obtenerSesion();

      if (response.result)
      {
        setProfile(response.data);
        getModules(response.data.group);
        localStorage.setItem('sesionIniciada', JSON.stringify(response.data));
      }
      else
        navigate("/login");
    }
    catch (error) //ocurre un error
    {
      navigate("/login");
    }
  }

   //en base al perfil del usuario logueado - activa / desactiva modulos
  const getModules = (group) => {
    switch (group)
    {
      case 1:
        setDashboardVisible(true);
        setTablasVisible(true);
        setGraficasVisible(true);
      break;

      case 2:
        setDashboardVisible(false);
        setTablasVisible(true);
        setGraficasVisible(true);
      break;

      case 3:
        setDashboardVisible(true);
        setTablasVisible(false);
        setGraficasVisible(false);
      break;

      default:
        setDashboardVisible(false);
        setTablasVisible(false);
        setGraficasVisible(false);
      break;
    }
  }

  //cierra la sesion del usuario logueado
  const closeSesion = async()=> {
    try{
      localStorage.removeItem("token");
      await cerrarSesion();
      navigate("/login");
    }
    catch(ex){
      console.log({ex})
    }
  }

  //controla el menu de "ajustes de cuenta"
  const [anchorEl, setAnchorEl] = useState(null);
  const open = Boolean(anchorEl);
  
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };

  const handleClose = () => {
    setAnchorEl(null);
  };

  //props del menu de "ajustes de cuenta"
  const menuProps = {
    paper: {
      elevation: 0,
      sx: {
        overflow: "visible",
        backgroundColor: "#5d6465",
        filter: "drop-shadow(0px 2px 8px rgba(0,0,0,0.32))",
        mt: 1.5,
        "& .MuiAvatar-root": {
          width: 32,
          height: 32,
          ml: -0.5,
          mr: 1,
        },
        "&::before": {
          content: '""',
          display: "block",
          position: "absolute",
          backgroundColor: "#5d6465",
          top: 0,
          right: 14,
          width: 10,
          height: 10,
          transform: "translateY(-50%) rotate(45deg)",
          zIndex: 0,
        },
      },
    },
  };


  //abre el menu mobile
  const [openMenu, setOpenMenu] = React.useState(false);
  const toggleDrawer = (newOpen) => () => {
    setOpenMenu(newOpen);
  };

  const menuItems = [
    { label: 'Graficas', icon: <InfoIcon className="text-amarillo" size="md" onClick={() => navigate("/graphs")} /> },
    { label: 'Tablas Dinamicas', icon: <ContactSupportIcon className="text-amarillo" size="md"  onClick={() => navigate("/dynamic-tables")} /> },
    { label: 'Portfolio', icon: <NextWeekIcon className="text-amarillo" size="md" /> },
    { label: 'Preguntas Frecuentes', icon: <HelpIcon className="text-amarillo" size="md" /> },
  ];

  const menuUser = [
    { label: `${profile?.name} ${profile?.surname1} ${profile?.surname2}` , icon: <AccountCircleIcon className="text-amarillo" size="md" /> },
    { label: 'Cerrar Sesión', icon: <Logout className="text-amarillo" size="md" /> },
  ];

  const MobileMenu = (
    <Box sx={{ width: 270 }} role="presentation" onClick={toggleDrawer(false)}>
      <List>
        {menuItems.map(({ label, icon }) => (
          <ListItem key={label} disablePadding>
            <ListItemButton>
              <ListItemIcon>{icon}</ListItemIcon>
              <ListItemText primary={label} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider sx={{ borderColor: 'white' }}/>
      {isUserLogged &&  
        menuUser.map(({ label, icon }) => (
          <ListItem key={label} disablePadding onClick={label === 'Cerrar Sesión' ? closeSesion : undefined}>
            <ListItemButton>
              <ListItemIcon>{icon}</ListItemIcon>
              <ListItemText primary={label} />
            </ListItemButton>
          </ListItem>
        ))
      }
    </Box>
  );

  return (
    <div className="w-full h-screen overflow-y-auto bg-ceniza">
      <nav className="block p-3 w-[100%] text-white bg-ceniza shadow-lg  ">
        <div className="container flex flex-wrap items-center justify-between mx-auto text-gray-100">
          {/* Logo */}
          <a
            href="#"
            className="text-blanco font-worksans text-[20px] font-bold leading-[23px] tracking-[-0.4px] uppercase no-underline flex"
          >
            <img
              className="w-[38px] h-[38px] mx-auto"
              src={LogoPico}
              alt="logo"
            />
            <span className="mt-3 text-[#484d50]"> SmartMine </span>
            <span className="mt-3 text-[#c2a435]"> Code </span>
          </a>

          <div className="hidden lg:block">
            <ul className="flex flex-col gap-2 mt-2 mb-4 lg:mb-0 lg:mt-0 lg:flex-row lg:items-center lg:gap-6">
              
              {profile?.isAdmin == 1 && (
                <li className="flex items-center p-1 text-sm gap-x-2 text-blanco bg-amarillo rounded-lg">
                  <Link to="/admin-suite" className="flex items-center">
                    Admin Suite
                  </Link>
                </li>
              )}
              
              {dashboardVisible && (
                <li className="flex items-center p-1 text-sm gap-x-2 text-blanco">
                  <Link to="/" className="flex items-center">
                    Dashboard
                  </Link>
                </li>
              )}

              {graficasVisible && (
                <li className="flex items-center p-1 text-sm gap-x-2 text-blanco">
                  <Link to="/alter-graphs" className="flex items-center">
                    Graficas
                  </Link>
                </li>
              )}

              {tablasVisible && (
                <li className="flex items-center p-1 text-sm gap-x-2 text-blanco">
                  <Link to="/dynamic-tables" className="flex items-center">
                    Tablas dinámicas
                  </Link>
                </li>
              )}
             
              {/* Informacion personal y cerrar sesion */}
              {isUserLogged &&  (
                <li className="flex items-center p-1 text-sm gap-x-2">
                  <IconButton onClick={handleClick} size="small" sx={{ ml: 2 }}>
                    <AccountCircleIcon className="text-amarillo" size="md" />
                  </IconButton>

                  <Menu
                    anchorEl={anchorEl}
                    id="account-menu"
                    open={open}
                    onClose={handleClose}
                    onClick={handleClose}
                    slotProps={menuProps}
                    transformOrigin={{ horizontal: "right", vertical: "top" }}
                    anchorOrigin={{ horizontal: "right", vertical: "bottom" }}
                  >
                    <MenuItem onClick={handleClose}>
                      <AccountCircleIcon className="text-blanco" size="md"/>
                      <span className="ml-2 text-blanco">  {profile?.name + " " + profile?.surname1 + " " + profile?.surname2} </span>
                    </MenuItem>
                  
                    <Divider />
                    
                    <MenuItem onClick={closeSesion}>
                      <ListItemIcon>
                        <Logout fontSize="small" className="text-blanco" />
                      </ListItemIcon>
                      <span className="text-blanco">  Cerrar Sesión </span>
                    </MenuItem>
                  </Menu>
                </li>
              )}

            </ul>
          </div>

          {/* Boton */}
          <button
            onClick={toggleDrawer(true)}
            className="relative ml-auto h-6 max-h-[40px] w-6 max-w-[40px] select-none rounded-lg text-center align-middle text-xs font-medium uppercase text-inherit transition-all hover:bg-transparent focus:bg-transparent active:bg-transparent disabled:pointer-events-none disabled:opacity-50 disabled:shadow-none lg:hidden"
            type="button"
          >
            <span className="absolute transform -translate-x-1/2 -translate-y-1/2 top-1/2 left-1/2">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                className="w-6 h-6"
                fill="none"
                stroke="currentColor"
                stroke-width="2"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M4 6h16M4 12h16M4 18h16"
                ></path>
              </svg>
            </span>
          </button>

          {/* Menu mobile */}
          <Drawer 
            open={openMenu}
            onClose={toggleDrawer(false)} 
            PaperProps={{
              sx: { backgroundColor: "#17181a", color: "#fffcfc" } // color opcional del texto
            }}>
            {MobileMenu}
          </Drawer>
    
        </div>
      </nav>

      {/* Aquí se insertará la ruta hija */}
      <div className="p-5">
        <Outlet />
      </div>
    </div>
  );
};

export default MainLayout;
